import { render, staticRenderFns } from "./sticky-bar.vue?vue&type=template&id=08247be7&scoped=true&"
import script from "./sticky-bar.vue?vue&type=script&lang=js&"
export * from "./sticky-bar.vue?vue&type=script&lang=js&"
import style0 from "./sticky-bar.vue?vue&type=style&index=0&id=08247be7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08247be7",
  null
  
)

export default component.exports